import { apiFetch, API_BASE } from '../api/client'

// Fetch the current RP month once. Returns null on failure.
export async function fetchCurrentMonth() {
  try {
    const resp = await apiFetch(`${API_BASE}/game/date/current`)
    if (!resp.ok) return null
    const body = await resp.json()
    if (!body.success) return null
    return body.data?.month ?? null
  } catch {
    return null
  }
}

// Mirrors the seasons seed in PR_API/datas/db_schemas/weather_engine.sql:
// north/equator follow the standard calendar, south is offset by 6 months.
export function getSeason(hemisphere, month) {
  if (!month) return null
  if (hemisphere === 'south') {
    if ([6, 7, 8].includes(month)) return 'Hiver'
    if ([9, 10, 11].includes(month)) return 'Printemps'
    if ([12, 1, 2].includes(month)) return 'Été'
    return 'Automne'
  }
  if ([12, 1, 2].includes(month)) return 'Hiver'
  if ([3, 4, 5].includes(month)) return 'Printemps'
  if ([6, 7, 8].includes(month)) return 'Été'
  return 'Automne'
}
